export const BASE_URL = (process.env.NODE_ENV === 'production' ? 'api/v1/' : 'http://localhost:2228/api/v1/');//process.env.REACT_APP_BASE_URL;